<template>
    <div id="auctionPreview">
        <h2>{{ auction.name }}</h2>
        <ol class="breadcrumb">
            <li><a :href="base_path">Home</a></li>
            <li><a :href="base_path+'auctions'">Wholesale Auto Auction Locations</a></li>
            <li><a :href="(base_path+'?search_state='+auction.state)">{{ us_states[auction.state] }}</a></li>
            <li class="active">{{ auction.name }}</li>
        </ol>

        
        <div class="grid">
            <div class="col">
                <h3>Current Cars in {{ auction.name }} Run List</h3>
                <div class="infoSection">
                    <div :class="{vehicleCount:isMobile()}">
                        <p class="car"><CarIcon />{{ auction.vehicleCount }}</p>
                    </div>
                    <a v-if="isMobile()" href="#" class="btn laApp" @click.prevent="openApp()">Open Laser Appraiser</a>
                </div>
                <h3>Address & Contact Information</h3>
                <div class="infoSection">
                    <h4>{{ auction.name }} address:</h4>
                    <p class="address">
                        <HomeIcon />{{ auction.street }}<br />
                        {{ auction.city }}, {{ auction.state }} {{ auction.zipcode }}
                    </p>
                    <div class="line_break"></div>
                    <div class="contactSec">
                        <h4>Contact {{ auction.name }}:</h4>
                        <p v-if="auction.websiteUrl" class="website"><WebIcon /><a :href="auction.websiteUrl" target="_blank">{{ auction.websiteUrl }}</a></p>
                        <p v-if="auction.email" class="email"><MailIcon /><a :href="'mailto:'+auction.email" target="_blank">{{ auction.email }}</a></p>
                        <p v-if="auction.phone" class="phone"><SmartphoneIcon /><a :href="'tel:' + auction.phone">{{ auction.phone }}</a></p>
                    </div>
                    <div class="social">
                        <a v-if="auction.linkedInUrl" class="linkedIn" :href="auction.linkedInUrl" target="_blank"><LinkedInIcon />LinkedIn</a>
                        <a v-if="auction.facebookUrl" class="facebook" :href="auction.facebookUrl" target="_blank"><FacebookIcon />Facebook</a>
                        <a v-if="auction.twitterUrl" class="twitter" :href="auction.twitterUrl" target="_blank">
                            <svg viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="#000"/></svg>
                            X
                        </a>
                    </div>
                    
                    <a v-if="auction.phone" :href="'tel:'+auction.phone" class="btn callPhone">Call {{ auction.name }}</a>
                </div>
            </div>
            <div class="googleMapWrapper">
                <div id="gg-map" ref="gg-map"></div>
            </div>
        </div>
    </div>

</template>

<script>
import { defineComponent, ref } from 'vue'
import axios from 'axios'
// import '../assets/css/bootstrap.css'
import HomeIcon from 'vue-material-design-icons/Home.vue';
import MailIcon from 'vue-material-design-icons/Mail.vue';
import WebIcon from 'vue-material-design-icons/Web.vue';
import LinkedInIcon from 'vue-material-design-icons/Linkedin.vue';
import FacebookIcon from 'vue-material-design-icons/Facebook.vue';
import SmartphoneIcon from 'vue-material-design-icons/Phone.vue';
import CarIcon from 'vue-material-design-icons/Car.vue';
import 'vue-material-design-icons/styles.css';
import { Loader } from '@googlemaps/js-api-loader';
import { BASE_PATH, ENV, HOME_URL, WEB_USERNAME, WEB_PASS , us_states  } from '../constants/envrionment';

export default defineComponent({
    props:['state','auctionCode','name'],
    components: { 
        HomeIcon, 
        MailIcon, 
        SmartphoneIcon, 
        CarIcon, 
        WebIcon,
        LinkedInIcon,
        FacebookIcon,
    },
    setup() {

        let auction = ref({});
        let maps_api_key = ref('');
        let env = ref('');
        let home_url = ref('');
        let state_list = ref([]);
        let us_states = ref({});
        let base_path = BASE_PATH;
        // if we get the auction data from the auction list from the session storage, then save the array key here in case we need it
        let session_storage_key = ref('');

        return {Loader , auction,  env, maps_api_key, home_url, state_list, session_storage_key, us_states, base_path}

    },
    methods:{
        openApp (param) {
            
            let self = this;

            setTimeout(function () {

                window.location = self.home_url;
            }, 50);

            window.location = "labrb://wavis";

        },
        isMobile (param) {
            
            let hasTouchScreen = false;

            if ("maxTouchPoints" in navigator) {
                hasTouchScreen = navigator.maxTouchPoints > 0;

            } else if ("msMaxTouchPoints" in navigator) {
                hasTouchScreen = navigator.msMaxTouchPoints > 0;
            } else {
                const mQ = matchMedia?.("(pointer:coarse)");
                if (mQ?.media === "(pointer:coarse)") {
                    hasTouchScreen = !!mQ.matches;
                } else if ("orientation" in window) {
                    hasTouchScreen = true; // deprecated, but good fallback
                } else {
                    // Only as a last resort, fall back to user agent sniffing
                    hasTouchScreen = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
                }
            }

            return hasTouchScreen;
            // return true;
        },
        async updateLatAndLng (param) {
            let self = this,
                axiosParams = {};


            if(this.env == 'dev'){
                axiosParams['headers'] ={
                    authorization: "Basic " + btoa(WEB_USERNAME + ":" + WEB_PASS)
                }
            }

            param['auctionCode'] = this.auction.auctionCode;

            axiosParams['params'] = param;

            const res = await axios.get(this.home_url+'auctions/ajax/update_auction_latlng', axiosParams);       

            if(res.data.status){
                
                this.auction['lat'] = param['lat'];
                this.auction['lng'] = param['lng'];
            }
        },
        geocodeAddress(geocoder, resultsMap) {

            let self = this;

            geocoder.geocode({
                address: self.auction.street+', '+self.auction.city +', '+ self.auction.state +', '+ self.auction.zipcode
            }, function(results, status) {
                if (status === 'OK') {

                    let markerLocation = {
                        lat : results[0].geometry.location.lat(),
                        lng : results[0].geometry.location.lng()
                    };

                    self.updateLatAndLng(markerLocation)

                    self.setMarker(resultsMap,markerLocation)

                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
        },
        setMarker(resultsMap,position){

            var marker = new google.maps.Marker({
                map: resultsMap,
                position: position
            });

            resultsMap.setCenter(position);

            // let searchAddress = this.auction.street+', '+this.auction.city +', '+ this.auction.state +', '+ this.auction.zipcode;
            let searchAddress = `<div class="mapInfo">
                <p class="name">${this.auction.name}</p>
                <p class="address">
                    ${this.auction.street}, ${this.auction.city}, ${this.auction.state} ${this.auction.zipcode}
                </p>
                <p class="glink">
                    <a target="_blank" href="https://maps.google.com/maps?ll=${position.lat},${position.lng}">View on Google Maps</a>
                </p>
            </div>`;

            var infoWindow = new google.maps.InfoWindow({
                content: searchAddress
            });

            infoWindow.open(resultsMap, marker);
        },
    },
    async mounted() {

        let self = this;

        this.env = ENV;
        this.home_url = HOME_URL;
        this.us_states = us_states;
        this.maps_api_key = (ENV=='dev')?'AIzaSyBxngctGff0L1iKRyJPvV80RcmUYwZ44rI':'AIzaSyDdqm8Vao7D9l9gZq4WX_ZEEmqt1heYaEA'
        this.auction = auctionData;

        let heading = document.querySelector('#features > .container > h2')

        if(!heading){
            
            heading = document.querySelector('#features > .container > h3')

            if(!heading){
                heading = document.querySelector('#features > .container > h4')
            }
        }

        if(heading){
            heading.innerHTML = 'Laser Appraiser for '+self.auction.name
        }

        const loader = new Loader({
            apiKey: this.maps_api_key,
            version: "weekly",
        });
        
        const mapOptions = {
            center: {
                lat: 12.2293071,
                lng: 109.2021254,
            },
            zoom: 15,
        };

        if(self.auction['lat'] && self.auction['lng']){
            mapOptions['center'] = {
                lat: Number(self.auction['lat']),
                lng: Number(self.auction['lng']),
            }
        }
        
        loader.loadCallback((e) => {
            if (e) {
                console.log(e, "--");
            } else {
                const mapContainer = this.$refs["gg-map"];
                const map = new google.maps.Map(mapContainer, mapOptions);

                const geocoder = new google.maps.Geocoder();

                if(self.auction['lat'] && self.auction['lng']){
                    self.setMarker(map, {'lat':Number(self.auction['lat']),'lng':Number(self.auction['lng'])});
                }
                else{
                    self.geocodeAddress(geocoder, map);
                }
            }
        });

    },
})

</script>